import { Injectable } from '@angular/core';
import { GuardFn, GuardRef, GuardType } from '../functions/register-guard';

@Injectable()
export class GuardService {
  readonly #guards = new Map<GuardType, Set<GuardFn>>();

  get guardsMap(): Partial<Record<GuardType, GuardFn[]>> {
    const guardDict: Partial<Record<GuardType, GuardFn[]>> = {};

    for (const [type, guardFnSet] of this.#guards.entries()) {
      guardDict[type] = Array.from(guardFnSet.values() ?? []);
    }

    return guardDict;
  }

  guards(type: GuardType): GuardFn[] {
    return Array.from(this.#guards.get(type)?.values() ?? []);
  }

  registerGuard(type: GuardType, execute: GuardFn): GuardRef {
    const guards = this.#guards.get(type) ?? new Set();
    this.#guards.set(type, guards.add(execute));

    const unregister = () => {
      const guards = this.#guards.get(type);
      guards?.delete(execute);
      this.#guards.set(type, guards ?? new Set());
    };

    return {
      type,
      execute,
      unregister,
    };
  }

  unregisterGuard(ref: GuardRef): void {
    ref.unregister();
  }
}
